import * as React from 'react';
import { Parameters, PFTResults, StudyRelevantParameters, VolumetricParameter, FlowParameter, DiffusingCapacityParameter, PressureParameter } from '../../PulmonaryFunctionTests/Shared/PFTAPITypes';
import ParameterResult from '../../PulmonaryFunctionTests/Shared/ParameterResult';
import ResultsGroupHeading from './ResultsGroupHeading';
import { SessionTypes } from '../../misc/api/ApiSessionTypes';
import { useWebPortalLegacyClient } from '../../misc/api/WebPortalTokenClient';
import { ParameterCategoryType } from '../../misc/api/apiTypes';

export interface RepeatabilityTableProps {
    results: PFTResults;
    isLoading?: boolean;
    isRejected?: boolean;
    showConfiguredParametersOnly?: boolean;
    studyRelevantParameters?: StudyRelevantParameters;
    sessionType?: SessionTypes;
}

const RepeatabilityTable = (props: RepeatabilityTableProps) => {
    const [parameters, setParameters] = React.useState<Parameters>();
    const legacyClient = useWebPortalLegacyClient();

    React.useEffect(() => {
        const getParameters = async () => {
            let params;
            if (props.showConfiguredParametersOnly) {
                params = props.studyRelevantParameters.RepeatabilityParameters ?? props.studyRelevantParameters.DefaultRepeatabilityParameters;
            } else {
                params = props.results.DisplayRepeatabilityParameters;
            }
            if (props.sessionType) {
                const parametersResult = await legacyClient.getParametersBySessionType(props.sessionType);
                const repeatabilityParametersIds = parametersResult.filter(p => p.Category === ParameterCategoryType.RepeatabilityParameter).map(p => p.Id);
                params = params.filter(p => repeatabilityParametersIds.includes(p.Id));
            }
            setParameters(params);
        }

        getParameters();
    }, []);

    // HACK: This extra FEV1 & FVC comparison is needed due to an upstream issue where the unit type is set incorrectly
    const displayNameHack = (dp: VolumetricParameter | FlowParameter | DiffusingCapacityParameter | PressureParameter) => {
        if (dp.Identifier === "FVC")
            return "FVC (ml)";

        if (dp.Identifier === "FEV1")
            return "FEV1 (ml)";

        return dp.DisplayName;
    }

    const IsRejected = (overreaderAcceptability?: boolean, technicianAcceptability?: boolean) => {
        if (overreaderAcceptability === true) {
            return false;
        }

        if (overreaderAcceptability === false) {
            return true;
        }

        if (technicianAcceptability === true) {
            return false;
        }

        return true;
    }

    return (
        <>
            <ResultsGroupHeading resultsCount={props.results.TestResults.length} title="Repeatability" />

            {
                parameters ? parameters.map(dp => {
                    return (
                        <tr key={`Repeatability${dp.Identifier}${dp.Units}`}>
                            <td>{displayNameHack(dp)}</td>
                            {
                                props.results.TestResults.map((tr, trIndex) => {
                                    return <ParameterResult
                                               isRejected={IsRejected(tr.OverreaderAcceptability, tr.TechnicianAcceptability)}
                                               isLoading={props.isLoading}
                                               key={`RepeatabilityResult${dp}${tr.TestId}`}
                                               results={props.results.TestResults}
                                               testIndex={trIndex} 
                                               testNumber={tr.TestNumber}
                                               parameterId={dp.ParameterType}
                                               units={dp.Units}
                                               isRepeatability={true}
                                               automationSection='repeatability'
                                           />
                                })
                            }
                            <td>-</td>
                        </tr>
                    );
                }) : null
            }
        </>
    );
}

export default RepeatabilityTable;
